import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  class: "horizontal",
  d: "M12 5.5V19.5",
  stroke: "black",
  "stroke-width": "1.25",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5 12.5H19",
  stroke: "black",
  "stroke-width": "1.25",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'AccordionToggleIcon',
  props: {
    isExpanded: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(["accordion-toggle-icon", __props.isExpanded ? 'minus' : 'plus']),
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 2))
}
}

})